/*
 * CO - Aplicar cupom no carrinho sem reload.
 *
 * Checkbox com [data-conso-aplicar-cupom="CODIGO"]: marcar aplica o código no carrinho via
 * /cart/update.js, somando aos códigos que já estão lá; desmarcar tira só ele. Funciona
 * com o carrinho vazio: a Shopify guarda o código (applicable: false) e aplica quando
 * entra produto.
 *
 * [data-conso-cupom-auto="CODIGO"] (PDP de kit com o preço já com o cupom): aplica o código
 * ao abrir a página, se ainda não estiver no carrinho. Uma vez por sessão por código
 * (sessionStorage): se o cliente tirar o cupom no carrinho, não volta sozinho.
 *
 * Os códigos do carrinho ficam em <html data-conso-cupons="COD1 COD2">. O Horizon
 * re-renderiza o <product-price> na troca de variante e o checkbox volta desmarcado, por
 * isso um MutationObserver re-marca os checkboxes a partir desse atributo.
 */
(function () {
  if (window.__consoAplicarCupom) return;
  window.__consoAplicarCupom = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SELETOR = 'input[data-conso-aplicar-cupom]';

  function codigosDoCarrinho(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).map(function (d) {
      return String(d.code || '').toUpperCase();
    });
  }

  function codigoDe(input) {
    return String(input.getAttribute('data-conso-aplicar-cupom') || '').toUpperCase();
  }

  function atuais() {
    return (document.documentElement.getAttribute('data-conso-cupons') || '').split(' ').filter(Boolean);
  }

  function sincronizar() {
    var codigos = atuais();
    document.querySelectorAll(SELETOR).forEach(function (input) {
      var marcado = codigos.indexOf(codigoDe(input)) !== -1;
      if (input.checked !== marcado) input.checked = marcado;
    });
  }

  function marcar(codigos) {
    document.documentElement.setAttribute('data-conso-cupons', codigos.join(' '));
    sincronizar();
  }

  function lerCarrinho() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Otimista: o estado muda na hora (atributo do <html> + checkboxes) e as chamadas
     ao carrinho entram numa fila, uma por vez, cada uma lendo o carrinho e gravando
     o seu código. Só a resposta da ÚLTIMA chamada pendente reescreve o estado — antes
     disso, um re-render (morph do Horizon, card da Área de membros refeito pelo JS)
     sincronizava com o estado velho e o chip piscava ligado/desligado/ligado. Se
     a chamada falha, volta pro que o carrinho tem de verdade. */
  var pendentes = 0;
  var mexeu = false;
  var fila = Promise.resolve();

  function enviar(codigo, aplicar) {
    return lerCarrinho()
      .then(function (cart) {
        var codigos = codigosDoCarrinho(cart).filter(function (c) {
          return c !== codigo;
        });
        if (aplicar) codigos.push(codigo);
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codigos.join(',') }),
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
  }

  function alternar(input) {
    var codigo = codigoDe(input);
    var aplicar = input.checked;
    if (!codigo) return;

    var desejado = atuais().filter(function (c) {
      return c !== codigo;
    });
    if (aplicar) desejado.push(codigo);
    mexeu = true;
    marcar(desejado);

    pendentes++;
    fila = fila
      .then(function () {
        return enviar(codigo, aplicar);
      })
      .then(function (cart) {
        pendentes--;
        if (pendentes === 0) marcar(codigosDoCarrinho(cart));
      })
      .catch(function () {
        pendentes--;
        if (pendentes === 0) {
          lerCarrinho()
            .then(function (cart) {
              if (pendentes === 0) marcar(codigosDoCarrinho(cart));
            })
            .catch(function () {});
        }
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(SELETOR)) return;
    alternar(input);
  });

  var agendado = false;
  new MutationObserver(function () {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      sincronizar();
    });
  }).observe(document.body, { childList: true, subtree: true });

  function aplicarAuto(cart) {
    var noCarrinho = codigosDoCarrinho(cart);
    document.querySelectorAll('[data-conso-cupom-auto]').forEach(function (el) {
      var codigo = String(el.getAttribute('data-conso-cupom-auto') || '').toUpperCase();
      if (!codigo || noCarrinho.indexOf(codigo) !== -1) return;
      var chave = 'conso-cupom-auto:' + codigo;
      try {
        if (sessionStorage.getItem(chave)) return;
        sessionStorage.setItem(chave, '1');
      } catch (e) {}
      noCarrinho.push(codigo);
      mexeu = true;
      marcar(atuais().filter(function (c) { return c !== codigo; }).concat(codigo));
      pendentes++;
      fila = fila
        .then(function () { return enviar(codigo, true); })
        .then(function (c) { pendentes--; if (pendentes === 0) marcar(codigosDoCarrinho(c)); })
        .catch(function () { pendentes--; });
    });
  }

  // Estado inicial. Se o cliente já clicou antes desta resposta chegar, ela é velha.
  lerCarrinho()
    .then(function (cart) {
      if (!mexeu) marcar(codigosDoCarrinho(cart));
      aplicarAuto(cart);
    })
    .catch(function () {});
})();
